"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = exports.AssertionError = void 0;
class AssertionError extends Error {
    constructor(options) {
        options = options || {};
        if (!options.actual || !options.expected || !options.operator) {
            options.message || (options.message = `AssertionError`);
        }
        else {
            options.message || (options.message = `AssertionError: Expected "${options.actual}" to "${options.operator}" "${options.expected}".`);
        }
        super(options.message);
        this.actual = options.actual;
        this.expected = options.expected;
        this.operator = options.operator || "";
    }
}
exports.AssertionError = AssertionError;
const assert = (condition, options) => {
    if (!condition)
        throw new AssertionError(options);
};
exports.assert = assert;
//# sourceMappingURL=assert.js.map